module.exports = __webpack_public_path__ + "static/media/2.59ce5c97.png";